<script setup lang="ts">
useDefaultMeta({
  title: 'Aplikasi Kirim Paket COD Terbaik #1 Indonesia | KiriminAja',
  description:
    'Kirim paket ke seluruh Indonesia dengan pengiriman reguler KiriminAja! Ekspedisi terlengkap, bisa COD, &amp; tanpa minimum jumlah kiriman. Kirim sekarang!',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Apa itu KiriminAja Poin?',
    answer:
      '<p>KiriminAja Poin merupakan program loyalitas di mana pengguna bisa mengumpulkan poin setiap kali melakukan pengiriman paket di KiriminAja. Kamu perlu melakukan pendaftaran untuk bergabung dengan program ini.</p>'
  },
  {
    question: 'Bagaimana cara mengecek jumlah poin saya?',
    answer:
      '<p>Kamu bisa mengecek jumlah poin melalui akun kamu di aplikasi atau dashboard KiriminAja. Akses menu "KiriminAja Poin" dan pantau jumlah poin yang berhasil kamu kumpulkan.</p>'
  },
  {
    question: 'Apakah ada batas maksimum poin yang bisa dikumpulkan?',
    answer:
      '<p>Program KiriminAja Poin tidak memiliki batas maksimum akumulasi poin. Kirim paket sebanyak banyaknya dan kumpulkan semua poinnnya.</p>'
  },
  {
    question: 'Apakah poin yang sudah dikumpulkan memiliki masa berlaku?',
    answer:
      '<p>Ya, setiap poin yang kamu kumpulkan akan kedaluwarsa pada akhir tahun setiap tanggal 31 Desember. Pastikan untuk menukarkan poinmu dengan hadiah sebelum tanggal kedaluwarsa yang dapat kamu cek di akunmu.</p>'
  },
  {
    question: 'Saya sudah kirim paket, tapi mengapa tidak dapat poin?',
    answer: `<p>Kamu akan secara otomatis mendapatkan poin dari pengiriman paketmu. Pastikan kamu sudah bergabung dalam Program KiriminAja Poin. Cek selengkapnya <a href="https://help.kiriminaja.com/article/cara-menggunakan-kiriminaja-poin-di-dashboard-baru" target="_blank" class="text-primary underline">di sini</a>. Pastikan status paketmu sudah selesai. Poin estimasi belum akan masuk ke akunmu selama paket masih dalam pengiriman. Jika masih ada kendala, kamu bisa hubungi <a href="${createHotlineLink()}" target="_blank" class="text-primary underline">CS KiriminAja</a> dengan bukti order terkait.</p>`
  },
  {
    question: 'Apakah poin saya bisa ditransfer ke akun lain?',
    answer:
      '<p>Saat ini, poin tidak dapat ditransfer ke akun lain. Poin hanya bisa digunakan oleh pemilik akun yang terdaftar.</p>'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Dapat Banyak Hadiah dengan Kumpulkan Poin Setiap Hari"
      sub-title="KiriminAja Poin"
      description="Ayo terus kirim paket untuk dapatkan poin yang bisa kamu tukar dengan berbagai hadiah menarik tanpa diundi!"
      hero-image="/assets/batch-2/ka-poin-welcome-new.webp"
      :button-link="
        $utm.utmUrl('/register', {
          redirectTo: '/kiriminaja-point'
        })
      "
      button-label="Mulai Kumpulkan Poin"
    />
    <SolusiKiriminajaPoinGift />
    <SolusiKiriminajaPoinTutorialPoin />
    <FaqBase :faqs="faqs" />
    <CtaSection />
  </div>
</template>
